import React from 'react';

function AuthBrand(): React.ReactElement {
  return (
    <div className="auth-brand">
      <span className="auth-brand__logo" aria-hidden />
      <span className="auth-brand__wordmark">
        We<span className="auth-brand__wordmark-accent">Tree</span>
      </span>
    </div>
  );
}

export default AuthBrand;
